import { useEffect } from 'react';
import { Col, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { Button } from '../../../components/buttons/buttons';
import { FormWrapper } from '../../../components/formWrapper/form-wrapper';
import { ModalColumns } from '../Style';
import { SelectServiceType } from '../../../components/services/forms/SelectServiceType';
import SelectStatus from '../../ServicesHistory/components/modals/SelectStatus';
import { incidentsStatus } from '../../../config/constants/incidentsStatus';
import { useUserPendingsBoardSettings } from '../hooks/useUserPendingsBoardSettings';
import { SelectCompany } from '../../../components/services/forms/SelectCompany';
import { SelectUser } from '../../../components/users/SelectUser';

const excludedStatus = [9, 5, 8];

export const ServiceTypeFilterModal = ({ show, handleClose }) => {
  const [form] = Form.useForm();
  const { translate: t } = useDictionaryTranslation();
  const { userSettingData, updateUserBoardSettings } = useUserPendingsBoardSettings();
  const arrayStatus = Object.values(incidentsStatus).filter((value) => !excludedStatus.includes(value));

  const closeModal = () => {
    handleClose();
  };

  const handleSubmit = async () => {
    const formValues = form.getFieldsValue();
    const data = {
      customers: formValues.customers?.map((value) => value.value),
      assignedUsers: formValues.assignedUsers?.map((value) => value.value),
      serviceTypes: formValues.serviceTypes?.map((value) => value.value),
      serviceStatus: formValues.serviceStatus,
    };
    await updateUserBoardSettings(data);
    handleClose(true);
  };

  useEffect(() => {
    const serviceTypes = userSettingData?.serviceTypes?.map((value) => ({ value: value._id, label: value.name }));
    const customers = userSettingData?.customersData?.map((value) => ({ value: value._id, label: value.name }));
    const assignedUsers = userSettingData?.assignedUsersData?.map((value) => ({
      value: value._id,
      label: value.profile.name,
    }));
    const statusData = userSettingData?.serviceStatusData?.map((valueStatus) => valueStatus.status);

    form.setFieldsValue({
      serviceTypes,
      serviceStatus: statusData,
      customers,
      assignedUsers,
    });
  }, [userSettingData]);

  return (
    <ModalColumns
      title={t('filters')}
      destroyOnClose
      width="50%"
      height="50%"
      onCancel={closeModal}
      open={show}
      footer={null}
    >
      <FormWrapper>
        <Form name="filterform" layout="vertical" form={form} onFinish={handleSubmit}>
          <Row>
            <Col xs={24} md={12}>
              <Form.Item name="serviceTypes" label={t('serviceType')} valuePropName="selectedServiceType">
                <SelectServiceType multiple />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="serviceStatus" label={t('serviceStatus')}>
                <SelectStatus allowedStatus={arrayStatus} multiple />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="customers" label={t('customer')} valuePropName="selectedCompany">
                <SelectCompany multiple />
              </Form.Item>
            </Col>
            <Col md={12} xs={24}>
              <Form.Item name="assignedUsers" label={t('technician')} valuePropName="selectedUser">
                <SelectUser placeholder={t('technicianPlaceholder')} multiple />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Button form="filterform" key="submit" htmlType="submit" type="primary">
              {t('save')}
            </Button>
          </Row>
        </Form>
      </FormWrapper>
    </ModalColumns>
  );
};

ServiceTypeFilterModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  filters: PropTypes.shape({
    serviceTypes: PropTypes.array,
  }),
};
